import { concat, isArray, isEmpty, isString } from "lodash";
import React from "react";
import Text from "./Text";
import HorizontalScroll from "./HorizontalScroll";
import { memberStyle } from "data/commonClasses";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { getTranslationContent } from "functions";

const GeneralComponents = (props) => {
  let membersProps = props?.membersProps;
  let lang = props?.lang;
  let allPositions = props?.allPositions || [];
  let extraMembersNames = membersProps?.extraMembers || [];


  return membersProps && !isEmpty(membersProps) ? (
    <div className="my-5">
      <div className="px-5">
        <Text
          text={getTranslationContent(membersProps, "title", lang) || ""}
          bold
          sectionTitle
        />
        <Text
          text={getTranslationContent(membersProps, "description", lang) || ""}
          subtitle
          className="py-1"
        />
      </div>

      {extraMembersNames &&
      isArray(extraMembersNames) &&
      extraMembersNames?.length ? (
        <Swiper
          pagination={{
            dynamicBullets: true,
            clickable: true,
          }}
          slidesPerView={1}
          modules={[Pagination]}
          className="mt-4"
          spaceBetween={"10px"}
          breakpoints={{
            // when window width is >= 640px
            930: {
              slidesPerView: 2,
              spaceBetween: 40,
            },
            1250: {
              slidesPerView: 3,
              spaceBetween: 40,
            },
          }}
        >
          {(extraMembersNames || [])?.map((oneMember, index) => {
            let positionName =
              allPositions?.find(
                (onePosition) => onePosition?._id === oneMember?.positionId
              )?.name || "";
            return (
              <SwiperSlide key={index} className="mb-8">
                <div
                  key={`${index}-${
                    isString(oneMember) ? oneMember : oneMember?.memberName
                  }`}
                  className={memberStyle}
                >
                  <Text
                    subtitle
                    center
                    white
                    text={`${positionName ? positionName + " : " : ""} ${
                      oneMember?.memberName
                    }`}
                    className="whitespace-nowrap select-none w-full truncate"
                  />
                </div>
              </SwiperSlide>
            );
          })}
        </Swiper>
      ) : null}
    </div>
  ) : null;
};

export default GeneralComponents;
